export function MatchScore({ score, size = "sm" }) {
  const color =
    score >= 75 ? "text-emerald-700" : score >= 45 ? "text-slate-700" : "text-slate-400";
  const cls = size === "lg" ? "text-4xl" : "text-base";
  return (
    <span data-testid="match-score" className={`font-mono-num font-semibold ${color} ${cls}`}>
      {score}%
    </span>
  );
}
